import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subject, Observable } from 'rxjs';
import { ComponentType } from '../../_models/componentType';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Currency } from 'src/app/_models/currency';
import { ComponentTypeForFilter } from '../../_models/componentTypeForFilter';
import { AssetSearchParams } from 'src/app/_models/assetSearchParams';

@Injectable({
   providedIn: 'root',
})
export class ComponentTypeService {
   baseUrl = environment.apiUrl;
   componentTypeSelected = new Subject<ComponentType>();
   ImportSelected = new Subject<ComponentType>();
   constructor(private http: HttpClient) {}

   changeEditState(a: ComponentType) {
      this.componentTypeSelected.next(a);
   }
   changeImportState(componentType: ComponentType) {
      this.ImportSelected.next(componentType);
   }
   getLatestCode(): Observable<string> {
      const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
      const requestOptions: Object = {
         headers,
         responseType: 'text',
      };
      return this.http.get<string>(this.baseUrl + 'componenttype/lastcode', requestOptions);
   }
   getComponentTypesFull(): Observable<ComponentType[]> {
      return this.http.get<ComponentType[]>(this.baseUrl + 'componenttype/full');
   }
   getComponentTypesFullWithFilter(searchParams: AssetSearchParams): Observable<ComponentType[]> {
      const params = new HttpParams()
      .set('functionalLocation1', searchParams.functionalLocation1)
      .set('functionalLocation2', searchParams.functionalLocation2)
      .set('functionalLocation3', searchParams.functionalLocation3)
      .set('componentType', searchParams.componentType);
      return this.http.get<ComponentType[]>(this.baseUrl + 'componenttype/fullwithfilter', { params });
   }
  getComponentTypesUsedOnAssets(): Observable<ComponentTypeForFilter[]> {
    return this.http.get<ComponentTypeForFilter[]>(this.baseUrl + 'componenttype/usedonassets');
   }
  
   getComponentTypesForGrouping(activityId: string): Observable<ComponentType[]> {
      return this.http.get<ComponentType[]>(this.baseUrl + 'componenttype/group/' + encodeURIComponent(activityId));
   }

   getComponentType(id): Observable<ComponentType> {
      return this.http.get<ComponentType>(this.baseUrl + 'componenttype/' + encodeURIComponent(id));
   }
   getComponentTypesByAssetTypeId(assetTypeId: string): Observable<ComponentType[]> {
      return this.http.get<ComponentType[]>(this.baseUrl + 'componenttype/assettype/' + encodeURIComponent(assetTypeId));
   }
   getCurrencies(): Observable<Currency[]> {
      return this.http.get<Currency[]>(this.baseUrl + 'componenttype/currencylist');
   }
   updateComponentType(id: string, componentType: ComponentType) {
      return this.http.put(this.baseUrl + 'componenttype/' + encodeURIComponent(id), componentType);
   }
   createComponentType(componentType: ComponentType) {
      return this.http.post(this.baseUrl + 'componenttype', componentType);
   }
   deleteComponentType(id: string) {
      return this.http.delete(this.baseUrl + 'componenttype/' + encodeURIComponent(id));
   }
   export(OnlyTemplate: boolean): Observable<Blob> {
      // tslint:disable-next-line:max-line-length
      return this.http.get(this.baseUrl + 'componenttype/export/' + OnlyTemplate, {
         responseType: 'blob',
      });
   }
}
